import React from 'react';
import Layout from '../components/Layout';
import PageTitle from '../components/PageTitle';
import Section from '../components/Section';
import SimpleButton from '../components/SimpleButton';

import styles from './ContactPage.module.scss';

//https://www.netlify.com/blog/2017/07/20/how-to-integrate-netlifys-form-handling-in-a-react-app/#form-handling-with-static-site-generators
export const ContactPageTemplate = props => (
  <Layout>
    <PageTitle title="Contact" light />
    <Section light>
      <form
        name="contact"
        method="post"
        data-netlify="true"
        className={styles.wrapper}
        action="/thank-you"
      >
        <input type="hidden" name="form-name" value="contact" />
        <input
          type="text"
          name="name"
          placeholder="Your name"
          className={styles.input}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Your email"
          className={styles.input}
          required
        />
        <input
          type="text"
          name="subject"
          placeholder="Subject"
          className={styles.input}
          required
        />
        <textarea
          name="message"
          placeholder="Your message"
          className={styles.textarea}
          rows="10"
          required
        ></textarea>
        <SimpleButton tag="button" title="send" className={styles.button} />
      </form>
    </Section>
  </Layout>
);

const ContactPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  return <ContactPageTemplate />;
};

export default ContactPage;

export const pageQuery = graphql`
  query ContactPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "contact-page" } }) {
      frontmatter {
        templateKey
      }
    }
  }
`;
